import {
  TranscriptsHourlyStatisticsResponse,
  TranscriptHourlyResponse,
} from '@projects/shared/src/app/features/chat/interfaces/Reporting/TranscriptsHourlyStatisticsResponse';

export const hightchartDashboardChatVolumeConfig = (data: TranscriptsHourlyStatisticsResponse) => {
  let config: Highcharts.Options = {
    title: {
      text: '',
    },
    chart: {
      spacingLeft: 0,
      spacingRight: 0,
      spacingTop: 10,
      spacingBottom: 0,
      backgroundColor: 'transparent',
    },

    yAxis: {
      visible: true,
    },

    xAxis: {
      visible: true,
      type: 'datetime',
    },

    legend: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      formatter() {
        let series = this.points,
          xPos = this.x,
          ret = '';

        series!.forEach(function (point) {
          if (point.x === xPos) {
            ret += point.series.name + ': ' + point.y + '<br>';
          }
        });

        return ret;
      },
    },
    plotOptions: {
      spline: {
        marker: {
          enabled: false,
        },
      },
      series: {
        label: {
          connectorAllowed: false,
        },
      },
    },
    series: [
      {
        name: 'Chats',
        type: 'spline',
        marker: {
          enabled: true,
        },
        data: data.HourlyChat.map((d: TranscriptHourlyResponse) => [
          Date.UTC(0, 0, 0, d.Hour, 0, 0, 0),
          d.PerHourCount,
        ]),
      },
      {
        name: 'OfflineMessages',
        type: 'spline',
        marker: {
          enabled: true,
        },
        data: data.HourlyOfflineMessage.map((d: TranscriptHourlyResponse) => [
          Date.UTC(0, 0, 0, d.Hour, 0, 0, 0),
          d.PerHourCount,
        ]),
      },
    ],
  };
  return config;
};
